export default __webpack_public_path__ + "afecf035a50d8f040ab50d42720a7e30.png";